export default [
  {
    key: 'workouts',
    iconComponent: 'IconRun',
    routeName: 'Workouts',
    name: 'Тренировки',
  },
  {
    key: 'content-settings',
    iconComponent: 'IconContentSettings',
    routeName: 'ContentSettings',
    name: 'Настройки контента',
  },
];
